import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const EventNotificationsServiceContext = createContext(undefined)

const EventNotificationsServiceProvider = ({
  children,
  baseApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={EventNotificationsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={baseApiHost}
      valueCallback={(axios) => ({
        list: async (query) => {
          const {data} = await axios.get(
            `/api/v1/events/event_notifications${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.patch(`/api/v1/events/event_notifications/${id}`, payload)
          return data
        },
        updateBatch: async (payload) => {
          const {data} = await axios.patch(`/api/v1/events/event_notifications`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

EventNotificationsServiceProvider.propTypes = {
  children: PropTypes.any,
  baseApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useEventNotificationsService = () => {
  const context = useContext(EventNotificationsServiceContext)
  if (context === undefined) {
    throw new Error('EventNotificationsServiceContext was not provided. Make sure your component is a child of the EventNotificationsServiceProvider.')
  }
  return context
}

const useEventNotificationsQuery = ({query, ...otherProps}) => {
  const bankAccountsService = useEventNotificationsService()
  return useSimpleQuery({
    queryKey: `event_notifications-list-${JSON.stringify(query)}`,
    queryFn: async () => bankAccountsService.list(query),
    ...otherProps
  })
}

export {EventNotificationsServiceProvider, useEventNotificationsService, useEventNotificationsQuery}
